import QueryString from 'qs';

import { jsonApi } from '../client';
import { mergeOverwrite } from '../helpers/object';
import type { Resource } from '../types/resource';
import type { ResourceScoutApi } from '../types/resource-api';
import type { ScoutOption, ScoutQuery, SearchItem } from './types';

const scout = jsonApi('scout');

export const generateResourceScoutApi = <T = Resource>(
  path: string,
  mapItem: (item: T) => ScoutOption,
  defaultQuery: ScoutQuery = {},
): ResourceScoutApi<T> => {
  const resourceScout = jsonApi(`${path}`);

  const index = (query?: ScoutQuery): Promise<T[]> => {
    return resourceScout.post<T[]>('scout', mergeOverwrite(defaultQuery, query));
  };

  const options = async (query?: ScoutQuery): Promise<ScoutOption<T>[]> => {
    return index(mergeOverwrite(defaultQuery, query)).then((items) =>
      items.map((item) => ({ ...mapItem(item), item })),
    );
  };

  return {
    index,
    options,
  };
};

const index = (query: string): Promise<SearchItem[]> => {
  return scout.get(undefined, {
    searchParams: QueryString.stringify({
      query,
    }),
  });
};

export const scoutApi = {
  name: 'scout',
  index,
};
